/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CausaleCdLDTO,
  DataSourceLoadOptions,
} from '../models/index';
import {
    CausaleCdLDTOFromJSON,
    CausaleCdLDTOToJSON,
    DataSourceLoadOptionsFromJSON,
    DataSourceLoadOptionsToJSON,
} from '../models/index';

export interface GetCausaliCdlRichiedibiliRequest {
    loadOptions?: DataSourceLoadOptions;
}

/**
 * 
 */
export class CausaliCDLApi extends runtime.BaseAPI {

    /**
     */
    async getCausaliCdlRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CausaleCdLDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/CausaliCdL`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CausaleCdLDTOFromJSON));
    }

    /**
     */
    async getCausaliCdl(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CausaleCdLDTO>> {
        const response = await this.getCausaliCdlRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCausaliCdlRichiedibiliRaw(requestParameters: GetCausaliCdlRichiedibiliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CausaleCdLDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['loadOptions'] != null) {
            queryParameters['loadOptions'] = requestParameters['loadOptions'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/CausaliCdL/richiedibili`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CausaleCdLDTOFromJSON));
    }

    /**
     */
    async getCausaliCdlRichiedibili(requestParameters: GetCausaliCdlRichiedibiliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CausaleCdLDTO>> {
        const response = await this.getCausaliCdlRichiedibiliRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
